import React, { useState, useEffect } from 'react';
import Head from './components/Head';
import Body from './components/Body';
import Pagination from './components/Pagination';
import { TableContainer, Table, Paper } from '@material-ui/core';

import clearUrl from '../../helpers/clearUrl';

import { useHistory } from 'react-router-dom';

var moment = require('moment');

const DataTable = ({
  head,
  body,
  bodyColumn,
  linkPath,
  useUid = false,
  action = true,
  isSlug,
  totalPages,
  currentPage,
  setPageChange,
  noPagination,
  customActions,
  isDataGrid = false,
  orderDirections,
  setOrderDirections,
  setIsOrdering,
  isOrdering,
  isNotOrdenable,
}) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const newRows = body.map(row => {
      for (let obj of Object.keys(row)) {
        if (
          moment(row[obj], moment.ISO_8601, true).isValid() &&
          typeof row[obj] !== 'boolean' &&
          typeof row[obj] === 'string' &&
          row[obj] &&
          row[obj].length > 8
        )
          row[obj] = moment(row[obj]).format('LLL');
        if (typeof row[obj] === 'boolean') {
          row[obj] = row[obj].toString();
          row[obj] = row[obj] === 'true' ? '✅ Sim' : '⛔️ Não';
        }
        if (!head.includes(obj)) head.filter(header => header !== row[obj]);
        if (obj === 'email' && row[obj]) row[obj] = row[obj].toLowerCase();
      }
      return row;
    });
    setRows(newRows);
  }, [body]);

  const history = useHistory();

  const handleChooseItem = data => {
    if (isNotOrdenable) return;
    orderDirections.direction === 'DESC'
      ? setOrderDirections({
          ...orderDirections,
          item: data,
          direction: 'ASC',
        })
      : setOrderDirections({
          ...orderDirections,
          item: data,
          direction: 'DESC',
        });
    setIsOrdering(isOrdering + 1);
    changeUrl(data);
  };

  const changeUrl = () => {
    history.push('/' + clearUrl(true));
    window.history.pushState(
      {
        directions: orderDirections.direction,
        item: orderDirections.item === undefined ? head[0] : orderDirections.item,
      },
      'ordering',
      window.location.href + '?order=' + orderDirections.item + '&direction=' + orderDirections.direction
    );
  };

  return (
    <TableContainer component={Paper} data-testid="table-container">
      <Table style={{ minWidth: '650', cursor: 'pointer' }} aria-label="caption table">
        <Head tableCell={head} action={action ? true : false} handleChooseItem={handleChooseItem} />
        <Body
          tableRow={rows}
          rowContent={bodyColumn}
          path={linkPath}
          useUid={useUid}
          action={action}
          isSlug={isSlug}
          customActions={customActions}
        />
        {!noPagination && <Pagination totalPages={totalPages} page={currentPage} setPage={setPageChange} />}
      </Table>
    </TableContainer>
  );
};

export default DataTable;
